<div class="container" (pointerenter)="pointerEnter()" (pointermove)="pointerMove($event)" (pointerout)="pointerOut()">
	<div class="left-right">
		@if (arrivedEarly) {
			<mat-icon class="error" svgIcon="acies_shift_status_left-before"></mat-icon>
		}
		@if (arrivedOnTime) {
			<mat-icon class="ok" svgIcon="acies_shift_status_left-after"></mat-icon>
		}
		@if (arrivedLate) {
			<mat-icon class="error" svgIcon="acies_shift_status_right-after"></mat-icon>
		}
	</div>
	<div class="flex">
		@if (!hasAnyErrors) {
			<mat-icon class="ok" svgIcon="shift_checkmark" />
		}
		@if (insufficient) {
			<mat-icon class="error" svgIcon="acies_alarm--subtract"></mat-icon>
		}
		@if (exceeds) {
			<mat-icon class="ok" svgIcon="acies_alarm--add"></mat-icon>
		}
		@if (notAWorkday) {
			<mat-icon class="error" svgIcon="acies_calendar"></mat-icon>
		}
		@if (shiftNotEnded) {
			<mat-icon class="error" svgIcon="acies_in-progress--error"></mat-icon>
		}
	</div>
	<div class="left-right">
		@if (leftEarly) {
			<mat-icon class="error" svgIcon="acies_shift_status_left-before"></mat-icon>
		}
		@if (leftOnTime) {
			<mat-icon class="ok" svgIcon="acies_shift_status_right-before"></mat-icon>
		}
		@if (leftLate) {
			<mat-icon class="error" svgIcon="acies_shift_status_right-after"></mat-icon>
		}
	</div>
	@if (noShiftOnDate) {
		<div class="no-shift-on-date-indicator"></div>
	}
	<div class="hit-layer"></div>
</div>

<div [ngClass]="{ hidden: !showPopup }" #popup class="hover-popup">
	@for (message of errorMessages; track message) {
		<mat-chip-set>
			<mat-chip>
				{{ 'mes.shift.approval.errors.' + message.translation | translate: message.params }}
			</mat-chip>
		</mat-chip-set>
	}
</div>
